import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {


  email: string = '';
  emailSent: boolean = false;

  constructor(private authService: AuthService, private utilService: UtilitieService) { }

  async loginDialog() {
    this.authService.openLoginDialog();
  }

  async sendResetLink() {
    let emailRequest: boolean = await this.authService.passwordResetRequest(this.email)

    if (emailRequest) {
      this.emailSent = true;
      this.authService.openSnackBar('Email has been sent!', '');
      setTimeout(() => {
        this.emailSent = false;
      }, 5000);
      return;
    }

    this.authService.openSnackBar('There was an issue sending out email', '');
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(false);

  }
}
